import React, { useState } from 'react';
import { InputGroup, FormControl, Button, Glyphicon } from 'react-bootstrap';

export default function ToggleablePassword(props) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputGroup className="mb-3">
      <FormControl type={showPassword ? 'text' : 'password'} {...props} />
      <InputGroup.Button>
        <Button onClick={() => setShowPassword(!showPassword)}>
          <Glyphicon glyph={showPassword ? 'eye-close' : 'eye-open'} />
        </Button>
      </InputGroup.Button>
    </InputGroup>
  );
}
